import {UseMutationResult, useMutation} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

interface GetClassroomSummaryPayload {
  meetingId: string;
  occurenceId: string;
  puzzleId?: number;
}

export default function useGetClassroomSummaryApi(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: unknown) => void,
): UseMutationResult<any, unknown, GetClassroomSummaryPayload> {
  return useMutation<any, unknown, GetClassroomSummaryPayload>(
    async (payload: GetClassroomSummaryPayload) => {
      const response = await ChessRestClient.post(
        'classroom/v1/get_puzzle_summary/',
        payload,
      );
      console.log('get Classroom Summary response ', response.data);
      return response.data;
    },
    {
      onSuccess: (data: any) => {
        if (handleOnSuccess) {
          handleOnSuccess(data);
        }
      },
      onError: (error: unknown) => {
        console.error('Failed to get Classroom Summary :', error);
        if (handleOnError) {
          handleOnError(error);
        }
      },
    },
  );
}
